import { ref } from "vue";

const getCharacter = (id) => {
    const character = ref(null)
    const errorc = ref(null)

    const loadc = async() => {
        try {
            let characterdata = await fetch( 'https://rickandmortyapi.com/api/character/'+id )
            if( !characterdata.ok ) {
                throw Error('Computer says no!')
            }
            character.value = await characterdata.json()
                            console.log(characterdata)
        } catch (err) {
            errorc.value = err.message
            console.log( err.value )
        }
    }
    return { character, errorc, loadc }
}
export default getCharacter